// preferences.js — préférences de NOTIFICATIONS + CONFIDENTIALITÉ par utilisateur.
// Stockées dans le cloud Nakama (collection vg_prefs) avec repli localStorage. Cache mémoire + abonnés
// pour que les composants (notifieur d'ami, présence) réagissent immédiatement à un changement.
import { nakamaAuth } from './nakamaAuth';

export const DEFAULT_PREFS = {
  notif: {
    friendOnline: true,   // toast quand un ami se connecte
    friendRequest: true,  // notif de demande d'ami
    gameInvite: true,     // notif d'invitation à jouer
    levelUp: true,        // toast festif quand on monte de niveau
    news: true,           // nouveautés (jeux/vidéos) dans l'app
    email: true,          // emails (bienvenue, premium…)
  },
  privacy: {
    showOnline: true,      // apparaître EN LIGNE pour mes amis
    status: 'online',      // statut affiché : 'online' | 'away' (absent) | 'offline' (apparaître hors ligne)
    // Visibilité de MON statut d'activité pour mes amis :
    //   'detailed' = activité précise (jeu/mode/onglet…), 'generic' = juste « En ligne », 'hidden' = rien.
    statusVisibility: 'detailed',
    showGame: true,        // montrer LE JEU + LE MODE en cours dans mon statut (sinon « En ligne » générique)
    whoInvite: 'friends',  // qui peut m'inviter à jouer : 'friends' | 'everyone' | 'nobody'
    whoFriend: 'everyone', // qui peut m'envoyer une demande d'ami : 'everyone' | 'nobody'
  },
};

const COLLECTION = 'vg_prefs';
const KEY = 'settings';
let cache = null;
const subs = new Set();

function merge(stored) {
  const s = stored || {};
  return {
    notif: { ...DEFAULT_PREFS.notif, ...(s.notif || {}) },
    privacy: { ...DEFAULT_PREFS.privacy, ...(s.privacy || {}) },
  };
}

// Accès synchrone au cache (valeurs par défaut tant que non chargé).
export function getPrefs() { return cache || DEFAULT_PREFS; }

export async function loadPrefs() {
  const stored = await nakamaAuth.storageRead(COLLECTION, KEY, null);
  cache = merge(stored);
  applyPresence(cache);
  return cache;
}

export async function savePrefs(prefs) {
  cache = merge(prefs);
  await nakamaAuth.storageWrite(COLLECTION, KEY, cache);
  subs.forEach((cb) => { try { cb(cache); } catch { /* */ } });
  applyPresence(cache);
  return cache;
}

export function onPrefsChange(cb) { subs.add(cb); return () => subs.delete(cb); }

// Applique « apparaître en ligne » : statut invisible ('' = hors ligne pour Nakama) si désactivé.
function applyPresence(prefs) {
  try {
    if (prefs.privacy && prefs.privacy.showOnline === false) nakamaAuth.updateStatus('');
  } catch { /* */ }
}
